// extracted by mini-css-extract-plugin
export default {"item":"style_item__b7NaP","information":"style_information__geULd","subTitle":"style_subTitle__bdhtO","hideMargin":"style_hideMargin__GrVyW"};